import { useTheme } from "@/theme";

/**
 * Раньше тема жила в URL (`/dark`, `/booker-dark`, `/lean-dark`),
 * из-за чего один и тот же контент был доступен по нескольким адресам —
 * для поисковиков это дубли. Теперь адрес один, а тему отдаёт контекст.
 *
 * Функции оставлены с прежними именами и сигнатурами, чтобы компоненты
 * (LightNavbar, DarkNavbar, футеры и т.д.) не пришлось переписывать.
 */

/** Текущая страница в тёмной теме? */
export function useIsDarkPage(): boolean {
  return useTheme().isDark;
}

/**
 * Ссылка, «привязанная к теме». Сейчас адреса от темы не зависят,
 * поэтому функция возвращает ссылку как есть — но сигнатура сохранена.
 */
export function getThemedHref(target: string, _isDark?: boolean): string {
  return target;
}

/**
 * Канонические адреса. Используется для редиректов со старых
 * «тёмных» URL, которые остались в индексе и в чужих ссылках.
 */
export const LEGACY_DARK_REDIRECTS: Record<string, string> = {
  "/dark": "/",
  "/light": "/",
  "/booker-dark": "/booker",
  "/lean-dark": "/lean",
  "/solutions-dark": "/solutions",
};
